import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const automationBulkPauseAtom = createMutationAtomFactory(
  'automations.bulkPause',
  (params: { ids: string[] }) => ({
    automationsAutomationBulkPause: {
      __args: {
        input: { ids: params.ids },
      },
      successCount: true,
      failedCount: true,
      failedIds: true,
    },
  }),
);
